import Logo from 'components/Logo';
import StagingTag from 'components/StagingTag';
import { get } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import IntlMessages from 'utils/IntlMessages';

import { IAuthContainerProps } from './types';

const AuthPageContainerStyled = styled.div`
  min-height: 180px;
`;

const LogoContainerStyled = styled.div`
  padding: 30px;
`;

const AuthPageContainer: React.FC<IAuthContainerProps> = ({ children, className, header }) => (
  <div className={`gx-app-login-wrap ${className}`}>
    <div className='gx-app-login-container'>
      <AuthPageContainerStyled className='gx-app-login-main-content'>
        <LogoContainerStyled className='gx-app-logo-content'>
          {/* <div className='gx-app-logo-content-bg' style={{}} /> */}
          <StagingTag className='small right' />
          <div className='gx-app-logo'>
            <Logo style={{ marginBottom: 10, height: 35 }} />
          </div>
          <div className='gx-app-logo-wid'>
            <h1>{get(header, 'title') || <IntlMessages id='app.userAuth.signIn' />}</h1>
            <div>{get(header, 'content') || <IntlMessages id='app.userAuth.signInHeaderMessage' />}</div>
          </div>
        </LogoContainerStyled>
        {children}
      </AuthPageContainerStyled>
    </div>
  </div>
);

export default React.memo(AuthPageContainer);
